import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './AppRouter';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom'

const AppWithRouter = () => (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
)

ReactDOM.render(<AppWithRouter />, document.getElementById('root'));

serviceWorker.unregister();
